// HomeDashboardSection.styled.ts

import styled from "@emotion/styled";

export const SectionBody = styled.div`
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;
  // background-color: red;
  width: 65rem;
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin-top: 1.5rem;
`;

export const PageButton = styled.button`
  padding: 0.5rem 1rem;
  border-radius: 4px;
  border: 1px solid var(--mb-color-border);
  background: var(--mb-color-bg-white);
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
